export default "__VITE_ASSET__BY5UF89m__"